















import { Component, Vue } from 'vue-property-decorator'
@Component({
  name:'SupervisionMenu'
})
export default class SupervisionMenu extends Vue {
  private value:any=''
  private queryobj:any=[]
  private menuArr:any=[{
      title:'能源消费结构',
      path:'/energyConstruction',
      id:1
    },{
      title:'主要产品产量',
      path:'/majorProducts',
      id:2
    },{
      title:'单位产品能耗',
      path:'/specificEnergycons',
      id:3
    },{
      title:'单位产值能耗',
      path:'/specificEnergyconsValue',
      id:4
    },{
      title:'设备能效',
      path:'/equipmentEfficiency',
      id:5
    },{
      title:'碳排放',
      path:'/carbonEmission',
      id:6
    }]

  private handleRoute(){
      const curPath:string=this.$route.path
      this.queryobj=this.$route.query
      this.value=curPath

  }
  private onChange(e:any){
      if(e.target.value==this.$route.path){
          return false
      }
      this.value=e.target.value
      this.$router.push({path:e.target.value,query:this.queryobj})
  }
  created() {
    this.handleRoute()
  }
}
